import { render, staticRenderFns } from "./CompanyEditPage.vue?vue&type=template&id=151cc986&"
import script from "./CompanyEditPage.vue?vue&type=script&lang=js&"
export * from "./CompanyEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports